import { filter, map, isEmpty, each } from 'underscore';

const isValidEmailAddress = (address) => {
  const re = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(address).toLowerCase());
};

export const MAX_EMAIL_ADDRESSES_COUNT = 10;

export const genEmailAddresses = (emailAddresses) => {
  const trimmedAddress = map(emailAddresses, address => address.trim());
  const validEmailAddresses = filter(trimmedAddress, address => isValidEmailAddress(address));

  return validEmailAddresses.join(';');
};

export const canSendEmail = (validEmailAddresses, invalidEmailAddresses) =>
  validEmailAddresses.length > 0 &&
  validEmailAddresses.length <= MAX_EMAIL_ADDRESSES_COUNT &&
  invalidEmailAddresses.length === 0;

export const splitEmailAddresses = (emailAddresses) => {
  const validEmailAddresses = [];
  const invalidEmailAddresses = [];
  const trimmedAddress = map(emailAddresses, address => address.trim());
  each(trimmedAddress, (address) => {
    if (isEmpty(address.trim())) {
      return;
    }
    if (isValidEmailAddress(address)) {
      validEmailAddresses.push(address);
    } else {
      invalidEmailAddresses.push(address);
    }
  });
  return [validEmailAddresses, invalidEmailAddresses];
};
